import styled from '@emotion/styled'
import { css } from '@emotion/react'

const modalCloseStyles = ({ theme, isActive }) => css`
  label: modal__close;

  position: absolute;

  top: ${theme.spacings.mega};
  left: ${theme.spacings.mega};

  color: ${isActive ? theme.colors.white : theme.colors.n400};

  ${theme.media.giga} {
    display: none;
  }
`

const modalCloseTextStyles = ({ theme }) => css`
  label: modal__close-text;

  position: absolute;

  top: -28px;
  right: 0;

  display: none;

  align-items: center;
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  color: ${theme.colors.white};
  cursor: pointer;

  svg {
    display: block;

    width: 10px;
    height: 10px;
    margin-left: ${theme.spacings.byte};
  }

  ${theme.media.giga} {
    display: flex;
  }
`

const titleStyles = ({ theme, withMargin }) => css`
  label: modal__title;

  display: block;

  ${withMargin && `margin-bottom: ${theme.spacings.tera};`}

  color: ${theme.colors.black};

  font-size: ${theme.typography.headings.tera.fontSize};
  font-weight: 600;
  line-height: ${theme.typography.headings.tera.lineHeight};

  strong {
    color: ${theme.colors.p500};
  }
`

const textShareStyles = ({ theme }) => css`
  label: modal__text-share;

  display: flex;

  align-items: center;
  justify-content: center;
  margin-top: ${theme.spacings.mega};

  color: ${theme.colors.o500};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  line-height: 14px;

  span {
    margin-left: ${theme.spacings.byte};
  }

  svg {
    display: block;

    width: 12px;
    height: 12px;
  }

  @media (min-width: ${theme.media.tablet}) {
    display: none;
  }
`

const descriptionStyles = ({ theme, heading }) => css`
  label: modal__description;

  display: block;

  color: ${heading ? theme.colors.black : theme.colors.n500};

  font-size: 13px;
  font-weight: ${heading ? 600 : 400};
  line-height: ${theme.typography.subHeadings.mega.lineHeight};

  &:not(:last-child) {
    margin-bottom: ${heading
      ? `${theme.spacings.byte}`
      : `${theme.spacings.tera}`};
  }
`

export const ModalClose = styled('div')(modalCloseStyles)
export const ModalCloseText = styled('span')(modalCloseTextStyles)
export const Title = styled('span')(titleStyles)
export const TextShare = styled('span')(textShareStyles)
export const Description = styled('span')(descriptionStyles)
